import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCore = function SvgCore(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#121212",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FD8D37",
        fillRule: "evenodd",
        d: "m23.908 9.722-12.497 7.111v14.222l12.497 7.11 12.497-7.11V16.833zm.525-3.583a1.06 1.06 0 0 0-1.05 0L8.525 14.593A1.03 1.03 0 0 0 8 15.49V32.4c0 .37.2.711.525.896l14.858 8.455c.325.185.725.185 1.05 0l14.858-8.455c.325-.185.525-.526.525-.896v-16.91c0-.37-.2-.71-.525-.896z",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FD8D37",
        d: "m23.908 14.874-7.97 4.535v9.07l7.918 4.506a.1.1 0 0 1 .052.09v1.552c0 .08-.087.13-.157.09L14.757 29.6a.77.77 0 0 1-.394-.672v-9.966c0-.277.15-.534.394-.672l8.758-4.983a.8.8 0 0 1 .787 0l9.03 5.12c.069.039.07.137 0 .177-.532.312-.805.45-1.401.777a.11.11 0 0 1-.104 0z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FD8D37",
        d: "M25.22 24.136c0-.039.021-.074.056-.092l7.925-4.157a.105.105 0 0 1 .154.091v10.114c0 .037-.02.07-.052.09l-7.925 4.534a.105.105 0 0 1-.158-.09z"
    })));
};

export { SvgCore as ReactComponent };
//# sourceMappingURL=Core.svg.es.js.map
